import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/auth/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('views/auth/authentication/Register')));
const AuthForgotPassword = Loadable(lazy(() => import('views/auth/authentication/ForgotPassword')));
const AuthResetPassword = Loadable(lazy(() => import('views/auth/authentication/ResetPassword')));
const CodeVerification = Loadable(lazy(() => import('views/auth/authentication/CodeVerification')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '*',
            element: <AuthLogin />
        },
        {
            path: '/',
            element: <AuthLogin />
        },
        {
            path: '/register',
            element: <AuthRegister />
        },
        {
            path: '/forgot',
            element: <AuthForgotPassword />
        },
        {
            path: '/reset-password',
            element: <AuthResetPassword />
        },
        {
            path: '/verification',
            element: <CodeVerification />
        }
    ]
};

export default LoginRoutes;
